<app-icons></app-icons>

<div class="main">
  @if (showNavbar() && isLoggedIn) {
    <app-navbar class="top-bar"></app-navbar>
  }

  @if (showLoader()) {
    <div class="loader_main">
      <div class="loader"></div>
    </div>
  }

  <div class="content">
    <router-outlet (activate)="onActivate()"></router-outlet>
  </div>
</div>
